import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../configs/firebase";
import { useAuth } from "../../auth/AuthContext";

export const useBusinessInfo = () => {
  const { user } = useAuth();
  const [businessInfo, setBusinessInfo] = useState<any>({});

  useEffect(() => {
    if (!user) return;

    const fetchBusinessInfo = async () => {
      try {
        const docSnap = await getDoc(doc(db, "users", user.uid));
        if (docSnap.exists()) {
          const data = docSnap.data();
          if (Array.isArray(data.members)) {
            setBusinessInfo(data);
          }
        }
      } catch (err) {
        console.error("Failed to fetch business info:", err);
      }
    };

    fetchBusinessInfo();
  }, [user]);

  return { businessInfo };
};
